import { ReactNode } from 'react';
import styled from 'styled-components';

import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { useInfiniteScroll } from '@sorare/core/src/hooks/useInfiniteScroll';
import {
  laptopAndAbove,
  tabletAndAbove,
} from '@sorare/core/src/style/mediaQuery';

interface Props<T> {
  users: T[];
  renderUser: (user: T) => ReactNode;
  loadMore: () => void;
  hasNextPage: boolean;
  loading: boolean;
}

const Root = styled.div`
  padding: var(--double-unit) 0;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  flex-wrap: wrap;
  gap: var(--double-unit);
  @media ${tabletAndAbove} {
    grid-template-columns: repeat(2, 1fr);
  }
  @media ${laptopAndAbove} {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
`;

export const UserList = <T,>({
  users,
  renderUser,
  loadMore,
  hasNextPage,
  loading,
}: Props<T>) => {
  const { InfiniteScrollLoader } = useInfiniteScroll(
    loadMore,
    hasNextPage,
    loading
  );

  if (loading && !users) {
    return (
      <Root>
        <LoadingIndicator />
      </Root>
    );
  }
  if (!users) return null;

  return (
    <Root>
      <Content>{users.map(u => renderUser(u))}</Content>
      <InfiniteScrollLoader />
    </Root>
  );
};
